import { WsSalesSolutionAction, WsSalesSolutionItem } from "../../../core";




const getItemById = (
  items: (WsSalesSolutionItem | WsSalesSolutionAction)[],
  itemId: string
): WsSalesSolutionItem | WsSalesSolutionAction | undefined => {

  let value: WsSalesSolutionItem | WsSalesSolutionAction | undefined = undefined;

  if (items && items.length > 0) {

    items.forEach((item) => {

      if (item.id === itemId) {
        value = item;
      }

      // TODO: use instanceof
      if ('items' in item) {

        if (item.items) {

          const x = getItemById(item.items, itemId);

          if (x) {
            value = x;
          }
        }
      }

    });
  }

  return value;
};




const getItemByActionId = (
  items: (WsSalesSolutionItem | WsSalesSolutionAction)[],
  actionId: string
): WsSalesSolutionItem | WsSalesSolutionAction | undefined => {

  let value: WsSalesSolutionItem | WsSalesSolutionAction | undefined = undefined;

  if (items && items.length > 0) {

    items.forEach((item) => {

      // direct actions
      if (item.actions && item.actions.length > 0) {

        item.actions.forEach((action) => {

          if (action.id === actionId) {
            value = item;
          }

        });
      }

      // children actions
      if (item.actions && item.actions.length > 0) {

        // TODO: double-check if children actions can be iterated in a better way
        const x = getItemByActionId(item.actions, actionId);

        if (x) {
          value = x;
        }
      }

      // children items
      if ('items' in item) { // TODO: use instanceof

        if (item.items && item.items.length > 0) {

          const x = getItemByActionId(item.items, actionId);

          if (x) {
            value = x;
          }
        }
      }

    });
  }

  return value;
};




const getActionById = (
  items: (WsSalesSolutionItem | WsSalesSolutionAction)[],
  actionId: string
): WsSalesSolutionAction | undefined => {

  let value: WsSalesSolutionAction | undefined = undefined;

  items.forEach((item) => {

    if (item.id === actionId) {
      value = item as WsSalesSolutionAction;
    }

    // children actions
    if (item.actions && item.actions.length > 0) {

      // TODO: double-check if children actions can be iterated in a better way
      const x = getActionById(item.actions, actionId);

      if (x) {
        value = x;
      }
    }

    // children items
    if ('items' in item) { // TODO: use instanceof

      if (item.items && item.items.length > 0) {

        const x = getActionById(item.items, actionId);

        if (x) {
          value = x;
        }
      }
    }

  });

  return value;
};




const getActionByMetricId = (item: WsSalesSolutionItem, metricId: string) => {

  let value: any = undefined;

  if (item.items && item.items.length > 0) {
    item.items.forEach((i) => {

      const x = getActionByMetricId(i, metricId);

      if (x) {
        value = x;
      }

    });
  }

  if (item.actions && item.actions.length > 0) {
    item.actions.forEach((action) => {

      const m = action?.metrics?.find((metric) => metric.id === metricId);

      if (m) {
        value = action;
      }

    });
  }

  return value;
};




export {
  getItemById,
  getItemByActionId,
  getActionById,
  getActionByMetricId
};
